import React from 'react';
import Actions from "../modules/actions";
import { connect } from "react-redux";
import PlusImg from "../images/plus.png";
import subtractImg from "../images/subtract.png";
import { Grid, Typography } from "@material-ui/core";

const headerStyle = {
  color: "white",
  fontWeight: "bold",
  textAlign: "left",
  alignItems: "center",
}

const sectionStyle = {
  alignItems: "center",
  paddingTop: ".25rem",
  paddingBottom: ".25rem ",
  marginTop: ".25rem ",
  marginBottom: ".25rem",
  backgroundColor: "#3a8b68ff",
}

const mapStateToProps = (state, ownProps) => {
  return ({
    ...state.sections[ownProps.id],
  });
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  expand: () => dispatch(Actions.expandSection(ownProps.id)),
  collapse: () => dispatch(Actions.collapseSection(ownProps.id)),
});

// Bootstrap note: "xs" applies to all screen sizes
const Section = props => (
  <div className="Section">
    <Grid container spacing={1}>
   
      <Grid container spacing={2} item xs={12} style={sectionStyle} alignItems="center" justify="center" onClick={event => {
          if (event.target.className !== "MuiButton-label") {
            props.expanded ? props.collapse() : props.expand();
          }
        }}>
        <Grid item xs={2}>
          {props.expanded ?
            <img src={subtractImg} width="26px" height="26px" alt="Collapse"/>
          :
            <img src={PlusImg} width="26px" height="26px" alt="Expand"/>}
        </Grid>
        {
          // I can't just use one turnary here becasue JSX needs to be wrapped and I think the wrapping is pissing off Bootstrap
        }
        {props.headerBody &&
          <Grid item xs={5}>
            <Typography style={headerStyle} variant="h5">
              {props.header}
            </Typography>
          </Grid>}
        {props.headerBody &&
          <Grid item xs={5}>
            {props.headerBody}
          </Grid>}
        {!props.headerBody &&
          <Grid item xs={10}>
            <Typography style={headerStyle} variant="h5">
              {props.header}
            </Typography>
          </Grid>}
      </Grid>
      {props.expanded &&
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={1}/>
          <Grid item xs={11} >
            {props.children}
          </Grid>
        </Grid>
      }
    </Grid>
  </div>
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Section);


// WEBPACK FOOTER //
// ./src/pages/Section.js